// MyTabs.jsx
import React from "react";
import "./Steptabs.css";
import { Tabs } from "antd";

const { TabPane } = Tabs;

const StepTabs = ({ size, tabNames, children }) => {
  return (
    <Tabs
      defaultActiveKey="1"
      type="card"
      size={size}
      className="mytabs-custom"
    >
      {React.Children.map(children, (child, index) => {
        const tabName = Array.isArray(tabNames) ? tabNames[index] : null;
        const tabKey = String(index + 1);
        return (
          <TabPane key={tabKey} tab={tabName}>
            {child}
          </TabPane>
        );
      })}
    </Tabs>
  );
};

export default StepTabs;
